import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ModalDescription, ModalTitle } from '@tryhackme/thm-ui-components';
import type { ThemeColors } from '@tryhackme/thm-ui-components/dist/config/theme/theme.types';
import styled from 'styled-components';

export const StyledTagIcon = styled(FontAwesomeIcon)<{
  $color?: keyof Pick<ThemeColors, 'error' | 'success' | 'warning' | 'info'>;
}>`
  color: ${({ theme }) => theme.colors.background.main};
  background-color: ${({ theme, $color }) => ($color ? theme.colors[$color].main : theme.colors.grey[600])};
  padding: 0.5rem;
  border-radius: 10rem;
  height: 1.5rem;
  width: 1.5rem;
`;

export const StyledModalTitle = styled(ModalTitle)`
  display: flex;
  gap: 0.875rem;
  align-items: center;
  margin-bottom: 2.4rem;
`;

export const StyledModalDescription = styled(ModalDescription)`
  color: ${({ theme }) => theme.colors.text.main};
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  line-break: anywhere;
`;

export const StyledTooltipToast = styled.div`
  display: flex;
  padding: 1.6rem;
  justify-content: flex-start;
  align-items: start;
  gap: 1rem;
  border: 0.1rem solid ${({ theme }) => theme.colors.info.main};
  background: ${({ theme }) => theme.colors.info.lighter};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;

export const StyledFontAwesomeTooltipIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.background.main};
  background-color: ${({ theme }) => theme.colors.info.main};
  padding: 0.5rem;
  border-radius: 10rem;
  height: 1.2rem;
  min-width: 1.2rem;
`;

export const StyledFontAwesomeCommentIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.grey[600]};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  padding: 0.5rem;
`;

export const StyledButton = styled(Button)<{
  $color?: keyof Pick<ThemeColors, 'error' | 'success' | 'warning' | 'info'>;
}>`
  background-color: ${({ theme, $color }) => ($color ? theme.colors[$color].main : theme.colors.button)};
`;

export const NoCommentsContainer = styled.div`
  display: flex;
  padding: 1.6rem;
  justify-content: center;
  align-items: start;
  gap: 1rem;
  background: ${({ theme }) => theme.colors.info.light};
  border-radius: ${({ theme }) => theme.radius.small};
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
`;
